import React, { useRef } from 'react';
import { useIntersectionObserver } from '../../../hooks/useIntersectionObserver';
import './WhyAEO.css';

function WhyAEO() {
  const sectionRef = useRef(null);
  const isVisible = useIntersectionObserver(sectionRef);

  return (
    <section className="ai-search-impact" id="why-aeo" ref={sectionRef}>
      <div className="impact-background">
        <div className="gradient-overlay"></div>
        <div className="grid-pattern"></div>
      </div>

      <div className={`impact-content section-fade ${isVisible ? 'visible' : ''}`}>
        <h2>
          <span className="block">AI search is not SEO</span>
        </h2>

        <div className="impact-message">
          <p>
            Traditional SEO tactics only influence <span className="highlight">30%</span> of AI visibility. 
            We need to understand how these LLMs work to optimize for them.
          </p>
          <p>
            We've reverse-engineered AI Search algorithms to identify exactly 
            where brands lose visibility and implement targeted improvements.
          </p>
        </div>

        <div className="stats-container">
          <div className="stat-card">
            <div className="stat-number">25<span className="percent">%</span></div>
            <div className="stat-label">of SEO traffic moving to AI Search in 2025</div>
          </div>
          
          <div className="stat-card">
            <div className="stat-number">5.2B<span className="plus">+</span></div>
            <div className="stat-label">monthly visits to ChatGPT alone</div>
          </div>
          
          <div className="stat-card">
            <div className="stat-number">2.5<span className="plus">x</span></div>
            <div className="stat-label">higher conversion from AI recommendations</div>
          </div>
        </div>

       
      </div>
    </section>
  );
}

export default WhyAEO;